import * as Icons from "lucide-react";

import styles from "./icon-switch.module.scss";

const IconSwitch = ({ options = [], value, onChange, iconMap = {} }) => {
	return (
		<div className={styles.wrapper}>
			{options.map((opt) => {
				const isActive = value === opt.value;
				const Icon = iconMap[opt.icon] || Icons.SquareEqual;

				return (
					<div key={opt.value} className={`${styles.option} ${isActive ? styles.active : ""}`} onClick={() => onChange(opt.value)}>
						<Icon size={16} className={styles.icon} />
						<span>{opt.label}</span>
					</div>
				);
			})}
		</div>
	);
};

export default IconSwitch;
